import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Layout,
  Popover,
  Spin,
  Avatar as AvatarIcon,
  Badge,
  Menu,
  Dropdown,
} from 'antd';
import {
  registerUser,
  loginUser,
  logOut,
  showAuthModal,
  hideAuthModal,
} from '../../ducks/Auth/actions';
import { saveProfile } from '../../ducks/Profile/actions';
import Nubod from '../../assets/logos/Nubod-cropped.png';
import { clearProfile } from '../../ducks/Profile/actions';
import Avatar from '../../assets/images/avatar.png';
import { LoadingOutlined } from '@ant-design/icons';

import NubodBlack from '../../assets/logos/nubod-black.png';

import { clearRecipes } from '../../ducks/Recipe/actions';
import { signOut } from './../../helpers/auth';
import { setIsLogin } from '../../ducks/Global/actions';
import { OPEN_DRAWER } from '../../ducks/Global/constants';
// import SideDrawer from '../../components/SideDrawer';
import { AiOutlineSetting } from 'react-icons/ai';
import { MdArrowDropDown } from 'react-icons/md';
import { scrollToRef } from '../../ducks/Global/actions';
import './index.scss';
import { IoMdNotificationsOutline } from 'react-icons/io';
import {
  getAllUserNotifications,
  updateNotificationRead,
} from '../../ducks/Notifications/actions';
import FileTextOutlined from '@ant-design/icons/lib/icons/FileTextOutlined';
import moment from 'moment';
import DeleteOutlined from '@ant-design/icons/lib/icons/DeleteOutlined';
import { AiOutlineUserSwitch } from 'react-icons/ai';
import ChangelogIcon from '../ChangelogIcon';
import FeedbackIcon from '../FeedbackIcon';
import notificationService from '../../services/notificationService';
import ThemeToggle from '../ThemeToggle';

const { Header } = Layout;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

class PageHeader extends Component {
  constructor() {
    super();
    this.state = {
      isTop: true,
      active: '/',
      mobileMenu: false,
      isMobileWidth: false,
      showNotification: false,
      isDeleteId: null,
      isMarkAllRead: false,
      unreadCount: null, // null means "not loaded yet"
    };
  }

  componentDidMount() {
    document.addEventListener('scroll', () => {
      const isTop = window.scrollY < 100;
      if (isTop !== this.state.isTop) {
        this.onScroll(isTop);
      }
    });
    window.innerWidth <= 1050
      ? this.setState({ isMobileWidth: true })
      : this.setState({ isMobileWidth: false });

    // Load notifications and unread count on mount if user is authenticated
    if (this.props.auth && this.props.auth.user) {
      this.loadNotifications();
      this.loadUnreadCount();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.setState({
        active: nextProps.location.pathname.split('/').pop() || '/',
      });
    }
    window.addEventListener('resize', () => {
      window.innerWidth <= 1050
        ? this.setState({ isMobileWidth: true })
        : this.setState({ isMobileWidth: false });
    });
    if (window.location.href.indexOf('assessment') > -1) {
      this.setState({ isLogin: false });
    } else {
      this.setState({ isLogin: true });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.auth &&
      this.props.auth &&
      this.props.auth.user &&
      prevProps.auth.user !== this.props.auth.user
    ) {
      this.loadNotifications();
      this.loadUnreadCount();
    }
  }

  componentWillMount() {
    this.setState({
      active: this.props.location.pathname.split('/').pop() || '/',
    });
  }

  setActive = (e, active) => {
    window.location.pathname.split('/');
    this.setState({ active: active, mobileMenu: false });
  };

  onScroll = (isTop) => {
    this.setState({ isTop });
  };

  closeAuthModal = () => {
    this.props.hideAuthModal();
  };

  hideNotification = () => {
    this.setState({
      showNotification: false,
    });
  };

  handleShowNotification = (showNotification) => {
    this.setState({ showNotification });
  };

  loadNotifications = async () => {
    if (!this.props.auth || !this.props.auth.user) return;

    try {
      // Fetch notifications from new FCM API
      const response = await notificationService.getNotifications({
        limit: 20,
      });

      // Update Redux state with new notifications
      if (response.notifications) {
        // Dispatch to update notifications in Redux
        this.props.setNotifications(response.notifications);
      }
    } catch (error) {
      console.error('Error loading notifications:', error);
    }
  };

  loadUnreadCount = async () => {
    if (!this.props.auth || !this.props.auth.user) return;

    try {
      const count = await notificationService.getUnreadCount();
      // Store unread count in component state for badge display
      this.setState({ unreadCount: count });
    } catch (error) {
      console.error('Error loading unread count:', error);
    }
  };

  handleDeleteNotification = async (notificationObj) => {
    this.setState({ isDeleteId: notificationObj._id, isMarkAllRead: false });

    try {
      await notificationService.deleteNotification(notificationObj._id);
      // Reload notifications and unread count after deletion
      await this.loadNotifications();
      await this.loadUnreadCount();
    } catch (error) {
      console.error('Error deleting notification:', error);
    }
  };

  handleMarkAsRead = async (notificationObj) => {
    this.setState({ isDeleteId: null, isMarkAllRead: false });

    try {
      await notificationService.markAsRead(notificationObj._id);
      // Update local state optimistically
      if (this.props.setNotificationAsRead) {
        this.props.setNotificationAsRead(notificationObj._id);
      }
      // Update unread count after marking as read
      await this.loadUnreadCount();
    } catch (error) {
      console.error('Error marking notification as read:', error);
    }
  };

  handleMarkAllAsRead = async () => {
    this.setState({ isDeleteId: null, isMarkAllRead: true });

    try {
      await notificationService.markAllAsRead();
      // Reload notifications and unread count after marking all as read
      await this.loadNotifications();
      await this.loadUnreadCount();
    } catch (error) {
      console.error('Error marking all notifications as read:', error);
    }
  };

  isLastMsgToday = (date) => {
    const lastMsgDate = moment(date).format('D MMM YYYY');
    const today = moment().format('D MMM YYYY');
    if (today === lastMsgDate) return true;
    else return false;
  };

  lastMsgDateNotToday = (date) => {
    if (!date) return moment().format('D MMM YYYY');
    const lastMsgDate = moment(date).format('D MMM YYYY');
    return lastMsgDate;
  };

  handleNotificationClick = (notificationObj) => {
    this.handleMarkAsRead(notificationObj);

    // Challenge notifications carry `data.cohortId` but a mobile-oriented
    // notificationUrl ('/challenge') that has no web route — route straight to
    // the challenge page. Covers launch/pre-start/reveal/wall-reply etc.
    // TRAINER-recipient ones (data.audience === 'trainer': a new wall post, or a
    // like on the trainer's own post) go to the admin cohort surface instead —
    // the client page renders the Wall without moderation/reply and, for a live
    // cohort the trainer only previews, can't even show the post. (M8)
    const cohortId = notificationObj.data?.cohortId;
    if (cohortId) {
      const base =
        notificationObj.data?.audience === 'trainer'
          ? '/dashboard/admin/challenges'
          : '/dashboard/challenges';
      this.props.history.push(`${base}/${cohortId}`);
      return;
    }

    // Support both old (url) and new (data.clickAction or data.notificationUrl) formats
    const clickUrl =
      notificationObj.data?.clickAction ||
      notificationObj.data?.notificationUrl ||
      notificationObj.url;

    if (clickUrl) {
      // If it's a full URL, open in new tab
      if (clickUrl.startsWith('http://') || clickUrl.startsWith('https://')) {
        window.open(clickUrl, '_blank');
      } else {
        // If it's a relative path, use React Router
        const url = clickUrl.split(`${process.env.REACT_APP_APP_URL}`);
        this.props.history.push(url[url.length - 1] || clickUrl);
      }
    }
  };

  getNotifications = () => {
    if (
      !this.props.userNotifications ||
      this.props.userNotifications.length === 0
    ) {
      return (
        <Menu.Item key='no-notifications'>
          <div
            style={{ padding: '20px', textAlign: 'center', color: '#6b7280' }}
          >
            You don't have any notifications.
          </div>
        </Menu.Item>
      );
    }

    return this.props.userNotifications.map((notificationObj) => {
      // Support both old OneSignal format (message) and new FCM format (message field)
      const message = notificationObj.message;

      return (
        <Menu.Item key={notificationObj._id || notificationObj.id}>
          <div className='notification-profile'>
            <div className='notification-profile-wrap'>
              <div
                className='flex flex-center-aligned'
                onClick={() => this.handleNotificationClick(notificationObj)}
              >
                <div className='notification-profile-img'>
                  <AvatarIcon
                    size={40}
                    src={require('../../assets/logos/nubod-logo.png')}
                  />
                  <span>
                    {/* Show green dot if notification is unread
                        Backend uses readAt field or status === 'pending' to indicate unread */}
                    {!notificationObj.readAt &&
                      notificationObj.status !== 'read' && (
                        <div className='notification-status read-notification' />
                      )}
                  </span>
                </div>
                <div className='notification-info-wrap'>
                  <div className='flex'>
                    <h5>{notificationObj.title}</h5>
                    <span className='notification-date'>
                      {notificationObj.createdAt
                        ? moment(notificationObj.createdAt).fromNow()
                        : this.isLastMsgToday(
                            notificationObj.data &&
                              notificationObj.data.fullDate
                          )
                        ? notificationObj.data && notificationObj.data.timeSet
                        : this.lastMsgDateNotToday(
                            notificationObj.data &&
                              notificationObj.data.fullDate
                          )}
                    </span>
                  </div>
                  {message && <p className='mt-1'>{message}</p>}
                </div>
              </div>
              <div className='delete-btn'>
                {this.props.notificationLoading &&
                this.state.isDeleteId ===
                  (notificationObj._id || notificationObj.id) ? (
                  <Spin indicator={antIcon} />
                ) : (
                  <DeleteOutlined
                    onClick={() =>
                      this.handleDeleteNotification(notificationObj)
                    }
                  />
                )}
              </div>
            </div>
            {
              <div>
                {notificationObj.data &&
                  notificationObj.data.files &&
                  notificationObj.data.files.map((file) => (
                    <div>
                      {file.fileType === 'image' ? (
                        <img
                          className='image-size'
                          src={`${process.env.REACT_APP_API_URL}${file.filePath}`}
                        />
                      ) : (
                        <div className='pdf-file-icon'>
                          <FileTextOutlined size={40} />
                          <div>
                            <p
                              onClick={() => {
                                window.open(
                                  `${process.env.APP_API_URL}${file.filePath}`,
                                  '_blank',
                                  'fullscreen=yes'
                                );
                              }}
                            >
                              {file.fileName}
                            </p>
                            <p>{file.size}</p>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            }
          </div>
        </Menu.Item>
      );
    });
  };

  getUnreadMsgCount = (notifications) => {
    if (!notifications) {
      return 0;
    }
    // Count notifications that don't have readAt timestamp or aren't marked as read
    return notifications.filter(
      (notif) => !notif.readAt && notif.status !== 'read'
    ).length;
  };

  renderDashboardHeader = () => {
    // Replaced by `<AppShell>`'s sticky Topbar (src/components/AppShell/Topbar.js).
    // The dashboard branch of PageHeader is no longer rendered; this component
    // now only renders the landing/marketing header on non-dashboard routes
    // via `renderLandingHeader`.
    return null;
    // eslint-disable-next-line no-unreachable
    const badgeCount =
      this.state.unreadCount !== null
        ? this.state.unreadCount
        : this.getUnreadMsgCount(this.props.userNotifications);

    return (
      this.props.history.location.pathname.split('/').includes('dashboard') && (
        <Header className='dashboard-header'>
          <div className='user-dropdown'>
            <div
              className='logo-section'
              onClick={() => window.open('https://www.getnubod.com', '_self')}
            >
              <div
                className='logo-image'
                style={{ backgroundImage: `url(${Nubod})` }}
              />
            </div>
            {this.props.auth && this.props.auth.isAuthenticated && (
              <div className='menu-right'>
                <>
                  <Dropdown
                    overlay={this.renderSettingsMenu()}
                    trigger={['click']}
                  >
                    <div className='page-header-menu-item flex flex-center-aligned'>
                      <span className='menu-item-content'>
                        <AiOutlineSetting
                          style={{ fontSize: '18px', marginRight: '3px' }}
                        />
                        <p style={{ fontSize: '14px' }}>Settings</p>
                        <MdArrowDropDown style={{ fontSize: '18px' }} />
                      </span>
                    </div>
                  </Dropdown>
                </>

                {/* Feature requests (Canny boards) */}
                <div className='bell flex flex-center-aligned'>
                  <FeedbackIcon />
                </div>

                {/* Changelog Icon */}
                <div className='bell flex flex-center-aligned'>
                  <ChangelogIcon />
                </div>

                {/* Light / dark / system theme toggle. Cycles on click;
                    persists choice in localStorage. */}
                <div className='bell flex flex-center-aligned'>
                  <ThemeToggle />
                </div>

                <div className='bell flex flex-center-aligned'>
                  <Dropdown
                    overlay={this.renderNotificationsMenu()}
                    trigger={['click']}
                    visible={this.state.showNotification}
                    onVisibleChange={this.handleShowNotification}
                  >
                    <Badge count={badgeCount}>
                      <IoMdNotificationsOutline />
                    </Badge>
                  </Dropdown>
                </div>
                <Dropdown
                  overlay={this.renderMenu()}
                  trigger={['click']}
                  style={{ cursor: 'pointer' }}
                >
                  <div className='dropdown flex flex-center-aligned'>
                    <img
                      alt='Avatar'
                      className='img'
                      src={this.props.auth.user.avatar || Avatar}
                    />
                  </div>
                </Dropdown>
              </div>
            )}
          </div>
        </Header>
      )
    );
  };

  handleMenuClick = (e, tab) => {
    if (e.key === '1' && tab === 'user') {
      signOut();
      this.props.clearRecipes();
      this.props.clearProfile();
      this.props.logOut();
      this.props.history.push('/');
    } else if (e.key === '1' && tab === 'settings') {
      this.props.history.push('/dashboard/settings');
    } else if (e.key === '2' && tab === 'settings') {
      this.props.history.push('/dashboard/settings');
    } else if (e.key === '3' && tab === 'settings') {
      this.props.history.push('/dashboard/settings/integrations');
    } else if (e.key === '4' && tab === 'settings') {
      this.props.history.push('/dashboard/settings/billing');
    } else if (e.key === '5' && tab === 'user') {
      this.props.history.push('/dashboard/profile');
    }
  };

  renderMenu = () => {
    return (
      <Menu
        className='nav-bar-menu'
        onClick={(e) => this.handleMenuClick(e, 'user')}
      >
        <div className='menu-item'>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: '8px',
            }}
          >
            <img
              alt='Avatar'
              className='img'
              src={this.props.auth.user.avatar || Avatar}
              style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                border: '2px solid #e5e7eb',
              }}
            />
            <div>
              <p
                style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: 'black',
                  margin: 0,
                }}
              >
                {this.props.auth.user.name} {this.props.auth.user.lastName}
              </p>
              <p
                style={{
                  fontSize: '12px',
                  lineHeight: '12px',
                  margin: 0,
                  color: '#6b7280',
                }}
              >
                {this.props.auth.user.email}
              </p>
            </div>
          </div>
        </div>
        <Menu.Item key='5'>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <AiOutlineUserSwitch
              style={{ fontSize: '16px', color: 'var(--primary, #8b5cf6)' }}
            />
            Profile
          </div>
        </Menu.Item>
        <Menu.Item key='1'>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <svg
              width='16'
              height='16'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2'
            >
              <path d='M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4'></path>
              <polyline points='16,17 21,12 16,7'></polyline>
              <line x1='21' y1='12' x2='9' y2='12'></line>
            </svg>
            Logout
          </div>
        </Menu.Item>
      </Menu>
    );
  };

  renderNotificationsMenu = () => {
    const badgeCount = this.getUnreadMsgCount(this.props.userNotifications);

    return (
      <Menu className='nav-bar-menu'>
        <div className='menu-item'>
          <p>Notifications</p>
          {this.props.userNotifications &&
          this.props.userNotifications.length > 0 &&
          !this.state.isDeleteId &&
          this.state.isMarkAllRead &&
          this.props.notificationLoading ? (
            <Spin indicator={antIcon} />
          ) : (
            this.props.userNotifications &&
            this.props.userNotifications.length > 0 &&
            badgeCount > 0 && (
              <p
                className='blue-link'
                onClick={() => this.handleMarkAllAsRead()}
              >
                Mark all as read
              </p>
            )
          )}
        </div>
        {this.props.notificationLoading &&
        (this.state.isDeleteId
          ? false
          : this.props.userNotifications.length === 0) ? (
          <Menu.Item key='loading'>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '20px',
              }}
            >
              <Spin indicator={antIcon} />
            </div>
          </Menu.Item>
        ) : (
          this.getNotifications()
        )}
      </Menu>
    );
  };

  renderSettingsMenu = () => {
    return (
      <Menu
        className='nav-bar-menu'
        onClick={(e) => this.handleMenuClick(e, 'settings')}
      >
        <Menu.Item key='1'>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <svg
              width='16'
              height='16'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2'
            >
              <circle cx='12' cy='12' r='3'></circle>
              <path d='M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1 1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z'></path>
            </svg>
            Account
          </div>
        </Menu.Item>
        <Menu.Item key='3'>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <svg
              width='16'
              height='16'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2'
            >
              <rect x='2' y='3' width='20' height='14' rx='2' ry='2'></rect>
              <line x1='8' y1='21' x2='16' y2='21'></line>
              <line x1='12' y1='17' x2='12' y2='21'></line>
            </svg>
            Integrations
          </div>
        </Menu.Item>
        {!this.props.auth.user.userType === 'fixed' && (
          <Menu.Item key='4'>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <svg
                width='16'
                height='16'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                strokeWidth='2'
              >
                <rect x='1' y='4' width='22' height='16' rx='2' ry='2'></rect>
                <line x1='1' y1='10' x2='23' y2='10'></line>
              </svg>
              Billing
            </div>
          </Menu.Item>
        )}
      </Menu>
    );
  };

  renderLandingHeader = () => {
    const isAssessment = window.location.href.indexOf('assessment') > -1;
    const isSharablePage = window.location.href.includes('share');
    if (isSharablePage) return null;
    return (
      !this.props.history.location.pathname
        .split('/')
        .includes('dashboard') && (
        <Header
          className={
            isAssessment
              ? 'header-navigation header-shadow'
              : 'header-navigation header-shadow login-header'
          }
          style={{ boxShadow: isAssessment && 'none' }}
        >
          <div className='header-content'>
            <div className='header-logo'>
              <img
                src={this.props.auth?.user?.branding?.logo || NubodBlack}
                className='alvaro-fitness-logo'
                alt={this.props.auth?.user?.branding?.name || 'Nubod'}
                // Render the raw uploaded logo (a Cloudinary display-transform
                // 400s when the account restricts derived transforms). If the
                // URL itself can't load, fall back to the Nubod mark rather
                // than a broken-image icon. `dataset` guard prevents a loop.
                onError={(e) => {
                  if (e.currentTarget.dataset.fellBack) return;
                  e.currentTarget.dataset.fellBack = '1';
                  e.currentTarget.src = NubodBlack;
                }}
                // Until auth.user resolves we don't yet know the trainer's
                // branding, so keep the logo hidden (space reserved) instead of
                // flashing the default Nubod mark over a trainer's brand.
                style={{
                  visibility: this.props.auth?.user ? 'visible' : 'hidden',
                }}
              />
            </div>
          </div>
        </Header>
      )
    );
  };

  render() {
    return (
      <React.Fragment>
        {this.renderDashboardHeader()}
        {this.renderLandingHeader()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    shouldShowAuthModal: state.auth.showAuthModal,
    authRedirectRoute: state.auth.authRedirectRoute,
    isLogin: state.global.isLogin,
    notificationLoading: state.notifications.notificationLoading,
    userNotifications: state.notifications.userNotifications,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    registerUser: (formData, cb) => dispatch(registerUser(formData, cb)),
    logOut: () => dispatch(logOut()),
    loginUser: (formData, cb) => dispatch(loginUser(formData, cb)),
    clearProfile: () => dispatch(clearProfile()),
    clearRecipes: () => dispatch(clearRecipes()),
    showAuthModal: () => dispatch(showAuthModal()),
    hideAuthModal: () => dispatch(hideAuthModal()),
    saveProfile: (payload) => dispatch(saveProfile(payload)),
    setIsLogin: (value) => dispatch(setIsLogin(value)),
    scrollToRef: (ref) => dispatch(scrollToRef(ref)),
    openDrawer: () => {
      return dispatch({
        type: OPEN_DRAWER,
      });
    },
    getAllUserNotifications: (userEmail) =>
      dispatch(getAllUserNotifications(userEmail)),
    setNotifications: (notifications) =>
      dispatch({
        type: 'GET_ALL_NOTIFICATIONS_SUCCESS',
        payload: notifications,
      }),
    setNotificationAsRead: (notificationId) =>
      dispatch(updateNotificationRead(notificationId)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PageHeader));
